import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import CantidadEstudiantes from "../../components/Form/Fields/CantidadEstudiantes";
import CaracteristicasEspacio from "../../components/Form/Fields/CaracteristicasEspacio";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DuracionActividad from "../../components/Form/Fields/DuracionActividad";
import TemaEvaluacion from "../../components/Form/Fields/TemaEvaluacion";
import ActividadesAplicacionCardImg from "../../components/UmmIApps/Cards/ActividadesAplicacionCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import { useAuthContext } from "../../hooks/Auth";
import { OASProvider } from "../../context/SuperAdmin/OASContexts/OASContext";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const ActividadesAplicacionPage = () => {

  const {
    nivelId,
    materiaId,
    mostrarCamposAvanzados,
    promptData,
    handleBack,
    setTextoInicial,
    toggleCamposAvanzados,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();

  const { user } = useAuthContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("actividades_aplicacion", { promptData });
  const colorIconBack = "#E29930";

  useEffect(() => {
    const init = {
      tema_evaluacion: "",
      condiciones_contexto: "",
      adaptaciones_curriculares: "",
      caracterizacion: "",
      duracion: 5,
      caracteristicas_espacio: "",
      cantidad_estudiantes: 1,
    };
    handleInitialPromptData(init, "actividades_aplicacion");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ActividadesAplicacionCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #F8ED9B 100%, #F1DB37 100%)"
        }
        titleColor="#F9A825"
        title="Actividades de aplicación"
        description="Crea actividades de evaluación que inviten a los estudiantes a aplicar sus conocimientos y habilidades, promoviendo una comprensión profunda y significativa de los contenidos."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
             
                <CurriculumTabs
                  nivelId={nivelId}
                  materiaId={materiaId}
                  nivelTPId={nivelTPId}
                  asignaturaTPId={asignaturaTPId}
                  handleNivelChange={handleNivelChange}
                  handleNivelTPChange={handleNivelTPChange}
                  handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                  handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                  clearTP={clearTP}
                  promptData={promptData}
                  setPromptData={setPromptData}
                />
              
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 3, mt: 3 }}>
            <TemaEvaluacion />
          </Grid>
          <Grid item xs={12}>
            <DuracionActividad />
          </Grid>
          <Grid item xs={12}>
            <CantidadEstudiantes />
          </Grid>

          <Grid item xs={12} container justifyContent="center" sx={{ mb: 3 }}>
            <Button
              variant="text"
              sx={{ color: "#336B87" }}
              onClick={toggleCamposAvanzados}
              endIcon={
                mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
              }
            >
              {mostrarCamposAvanzados
                ? "Ocultar opciones avanzadas"
                : "Mostrar opciones avanzadas (opcional)"}
            </Button>
          </Grid>
          {/* Campos avanzados */}
          {mostrarCamposAvanzados && (
            <>
              <Grid item xs={12}>
                <CondicionesContexto />
              </Grid>
              <Grid item xs={12}>
                <Caracterizacion />
              </Grid>
              <Grid item xs={12}>
                <AdaptacionesCurriculares />
              </Grid>

              <Grid item xs={12}>
                <CaracteristicasEspacio />
              </Grid>
            </>
          )}
        </>
      </UmmiaAppsLayout>
    </>
  );
};

export default ActividadesAplicacionPage;
